// Logo.js
import React from "react";
import logoImage from "../../images/LOGOpng.png"; // Importa l'immagine del logo
import './style/logo.css'

function Logo() {
  return (
    <div className="logo-container">
      <img src={logoImage} alt="Logo"/>
    </div>
  );
}

export default Logo;